module.exports = __webpack_public_path__ + "media/images/rocket-new-5d5a962da22d0730931ec42536dd937a.svg";